<script lang="ts" module>
  export const TUTORIAL_KIND = {
    OFF: "off",
    IMAGE: "image",
    VIDEO: "video",
  }
  export type TutorialKind = (typeof TUTORIAL_KIND)[keyof typeof TUTORIAL_KIND]
</script>

<script lang="ts">
  import { getApplicationStore } from "@/stores/application"
  import type { ComponentProps } from "svelte"
  import type Image from "./screens/Image.svelte"
  import type Video from "./screens/Video.svelte"

  let props: ComponentProps<typeof Image> | ComponentProps<typeof Video> = $props()

  const applicationStore = getApplicationStore()

  let screen = $derived(
    $applicationStore.config.tutorial === TUTORIAL_KIND.IMAGE
      ? import("./screens/Image.svelte")
      : import("./screens/Video.svelte"),
  )
</script>

{#await screen then Module}
  <Module.default {...props} />
{/await}
